import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'

import Label from '../Label'
import { InputWrapper, InputBase } from '../Input'

const TextFieldLabel = styled(Label)`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  transform: ${ifProp('shrink',
    'translate(0, 0) scale(0.75)',
    'translate(0, 1.3333333em) scale(1)'
  )};
  transition: transform 200ms ease-out;
  z-index: 0;

  & + ${InputWrapper} {
    margin-top: 1em;

    ${InputBase}::placeholder {
      opacity: ${ifProp('shrink', 1, 0)};
    }
  }
`

export default TextFieldLabel
